import {Injectable} from '@angular/core';
import {NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';

@Injectable({providedIn: 'root'})
export class CustomDatepickerConfig extends NgbDatepickerConfig {
  constructor() {
    super();
    // customize default values of datepickers used by this component tree
    this.minDate = {year: 2017, month: 1, day: 1};
    this.maxDate = {year: 2035, month: 12, day: 31};
    this.outsideDays = 'visible'; // days that don't belong to current month are not visible
    this.showWeekNumbers = false;
    this.firstDayOfWeek = 1; // Monday
    this.navigation = 'select';
    this.displayMonths = 1;
  }
}
